import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { CompanyPageCompanyFragment } from 'generated/graphql';
import { useState } from 'react';
import { toEnableDisableValue } from 'views/Company/CompanyView/CompanyView.helpers';
import { Button } from '@spotted-zebra-uk/ui-components';
import {
  APPLICATION_ANSWER_EVIDENCE_ENABLED_LABEL,
  NATIONALITY_SCRUTINY_ENABLED_LABEL,
  SHORTLISTING_ENABLED_LABEL,
  SHORTLISTING_SECTION_TITLE,
} from './ShortlistingSection.constants';
import ShortlistingSectionForm from './ShortlistingSectionForm';
import styles from './ShortlistingSection.module.scss';

type ShortlistingSectionProps = {
  company: CompanyPageCompanyFragment;
};

const ShortlistingSection = ({ company }: ShortlistingSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  return isEditing ? (
    <ShortlistingSectionForm
      company={company}
      onCancelClick={handleCancelClick}
      onSave={handleSave}
    />
  ) : (
    <ShortlistingSectionView company={company} onEditClick={handleEditClick} />
  );
};

const ShortlistingSectionView = ({
  company,
  onEditClick,
}: {
  company: CompanyPageCompanyFragment;
  onEditClick: () => void;
}) => (
  <div className={styles.viewContainer}>
    <div className={styles.header}>
      <h3 className={styles.title}>{SHORTLISTING_SECTION_TITLE}</h3>
      <Button variant="secondary" size="medium" onClick={onEditClick}>
        Edit
      </Button>
    </div>
    <div className={styles.content}>
      <InfoItem
        label={SHORTLISTING_ENABLED_LABEL}
        value={toEnableDisableValue(company.isShortlistingEnabled)}
      />
      <InfoItem
        label={NATIONALITY_SCRUTINY_ENABLED_LABEL}
        value={toEnableDisableValue(
          company.isAiShortlistNationalityScrutinyEnabled
        )}
      />
      <InfoItem
        label={APPLICATION_ANSWER_EVIDENCE_ENABLED_LABEL}
        value={toEnableDisableValue(company.isApplicationAnswerEvidenceEnabled)}
      />
    </div>
  </div>
);

export default ShortlistingSection;
